import dayjs, { type Dayjs } from "dayjs";
import { formatRedoCountdown } from "../utils/redoCountdown";

export default function RedoCountdown({ submitTime, now }: { submitTime?: string; now?: Dayjs }) {
    const label = formatRedoCountdown(submitTime, now ?? dayjs());
    if (!label) return null;
    return <span className="ltn-time">{label}</span>;
}
